/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'

@Injectable()
export class HttpErrorHandler {
  public static getErrorPageKeyByStatusCode(statusCode: number): string {
    return 'pidp.generic.backend.error'
  }

  public static getErrorNotificationKeyByStatusCode(statusCode: number): string {
    // So far we don't differentiate between the different 5xx status codes so -> always backend error
    return 'pidp.generic.backend.error'
  }
}
